import styled, { CSSProperties } from "styled-components";

interface IDiv {
	BackgroundImage: string;
}

export const Container = styled.div<IDiv>`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	position: relative;
	background-image: url(${(props) => props.BackgroundImage});
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	width: 100%;
	height: 69em;
	font-size: clamp(8px, 2.5dvw, 19px);

	@media (min-width: 734px) {
		height: 46.45em;
		font-size: clamp(2px, 0.92dvw, 12px);
	}
`;

export const OffersContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	z-index: 1;
	@media (min-width: 734px) {
		margin-top: 2em;
		flex-direction: row;
	}
`;

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;

	@media (min-width: 734px) {
		flex-direction: row;
	}
`;

export const Image = styled.img`
	width: 2.8em;
	margin-top: 1.8em;
	transform: rotate(0deg);

	@media (min-width: 734px) {
		width: 4em;
		margin-top: 4em;
		transform: rotate(-90deg);
	}
`;

export const BgBrush = styled.img`
	position: absolute;
	top: -1px;
	left: -1px;
	width: calc(100% + 2px);
	height: calc(100% + 2px);
	user-select: none;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	-webkit-touch-callout: none;
	-webkit-tap-highlight-color: transparent;
	pointer-events: none;
`;

export const Title = styled.div<IDiv>`
	content: url(${(props) => props.BackgroundImage});
	z-index: 1;
	width: auto;
	margin-top: 0.5em;
	height: 4.5em;

	@media (min-width: 734px) {
		margin-top: unset;
		margin-bottom: 0.5em;
		height: 7.75em;
	}
`;

export const ContributeToPoisText = styled.div`
	position: absolute;
	bottom: 2.5em;
	font-family: "Baloo";
	font-size: 1.29em;
	color: white;
	text-shadow: 0 0.14em #000;
	-webkit-text-stroke-width: 0.38em;
	-webkit-text-stroke-color: #000;
	paint-order: stroke fill;
	border-radius: 2em;
	background: rgba(0, 0, 0, 0.2);
	padding: 0.38em 0.88em;
	z-index: 1;

	@media (min-width: 734px) {
		bottom: 5%;
		font-size: 1.84em;
	}
`;

export const timerStyle: CSSProperties = {
	fontSize: "2em",
	whiteSpace: "nowrap",
	padding: "0.3em 0.6em",
	backgroundColor: "#fff",
	top: "10%",
	left: "50%",
	transform: "translate(-50%, -50%)"
};

export const timerStyleMobile: CSSProperties = {
	...timerStyle,
	fontSize: "1.2em",
	top: "5%"
};
